<template>
  <div class="page-content">
    <h1 class="page-title">{{ titleMapping[$route.name].title }}</h1>
    <el-form class="egl-elm egl-detail" :model="websiteGuideSettingInfo" label-position="top">
      <el-row v-if="!isRemarkPage">
        <el-col :span="24">
          <el-form-item :label="$locale('cinemaWebsite.custom.dialog.form.content')" :prop="$route.name">
            <editor v-model="websiteGuideSettingInfo[$route.name]" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else>
        <el-col :span="24">
          <el-form-item :label="$locale('cinemaWebsite.websiteGuideSetting.remark')" prop="addressInfo">
            <editor v-model="websiteGuideSettingInfo.addressInfo" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24" class="ta-r">
        <el-button style="width: 200px;" class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm2")
        }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Editor from "@/components/common/Tinymce/Rich";
import { getWebsiteSettingGuideService, updateWebsiteSettingGuideService } from "@/helpers/service/api/cinemaWebsite";
import countDownAlert from "@/utils/countDownAlert";
export default {
  data() {
    return {
      titleMapping: {
        admissionInfo: {
          title: this.$locale("sideMenu.cinemaWebsite.admissionInfo"),
        },
        notice: {
          title: this.$locale("sideMenu.cinemaWebsite.notice"),
        },
        commonProblems: {
          title: this.$locale("sideMenu.cinemaWebsite.commonProblems"),
        },
        privacyPolicy: {
          title: this.$locale("sideMenu.cinemaWebsite.privacyPolicy"),
        },
        serviceTerms: {
          title: this.$locale("sideMenu.cinemaWebsite.serviceTerms"),
        },
        serviceTermsRemark: {
          title: this.$locale("sideMenu.cinemaWebsite.serviceTermsRemark"),
        }
      },
      websiteGuideSettingInfo: {
        admissionInfo: "",
        notice: "",
        commonProblems: "",
        privacyPolicy: "",
        serviceTerms: "",
        addressInfo: "",
      }
    };
  },
  computed: {
    isRemarkPage() {
      return this.$route.name === "serviceTermsRemark";
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      Object.keys(this.websiteGuideSettingInfo).forEach(key => {
        this.websiteGuideSettingInfo[key] = "";
      });

      getWebsiteSettingGuideService({
        cinemaId: window.localStorage.getItem("cinemaId")
      }).then(res => {
        this.websiteGuideSettingInfo = {
          ...res.data,
          ...(this.isRemarkPage
            ? {}
            : { [this.$route.name]: this.$util.decodeBase64(res.data[this.$route.name]) })
        };
      });
    },
    requestScuessFn(res, countDownText) {
      if (!res.success) { return; }
      countDownAlert({
        content: countDownText
      });
    },
    save_fn() {
      const requestParam = {
        ...this.websiteGuideSettingInfo,
        cinemaId: window.localStorage.getItem("cinemaId"),
      };
      if (!this.isRemarkPage) {
        requestParam[this.$route.name] = this.$util.encodeBase64(this.websiteGuideSettingInfo[this.$route.name]);
      }
      updateWebsiteSettingGuideService(requestParam).then(res => {
        this.requestScuessFn(res, this.$locale("global.updateSuccessfully"));
      });
    }
  },
  components: {
    Editor
  },
  watch: {
    "$route": "getList"
  }
};
</script>